import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';

class Setting extends Component {
    componentDidMount() {
    }

    render() {
        return <div style={{ color: '#333', backgroundColor: '#fff' }}>
            <details>
                <summary>env</summary>
                <pre>{JSON.stringify(process.env, null, 4)}</pre>
            </details>
            <br></br>
            <details open>
                <summary>config</summary>
                <pre>{JSON.stringify({ buildAt: process.env.__APP_BUILD_TIMESTAMP__, ...this.props.config }, null, 4)}</pre>
            </details>
        </div>
    }
}
export default connect(state => ({
    config: state.application.config
}))(injectIntl(Setting));